import React from 'react';
import styled from 'styled-components';

const Container = styled.footer`
  height: 54px;
  background-color: #222;
  color: #bcbcbc;
  font-size: 14px;
`;

export default function Footer() {
  return (
    <Container />
  );
}
